import { type Graphics } from "pixi.js";

/**
 * Pencil-stroke painting shared by CardView (committed `ink` cards) and
 * CanvasView (the live stroke while the pencil is dragging), y las dos
 * conversiones de color que usa todo el render.
 */

/** "#rrggbb" → Pixi color number. */
export function inkColor(hex: string): number {
  return parseInt(hex.slice(1), 16);
}

/**
 * Paint one polyline as smoothed ink: quadratic curves through segment
 * midpoints, with the raw points as control points. A single point (a tap)
 * becomes a round dot. `pts` is a flattened [x0, y0, x1, y1, …] array in the
 * target Graphics' local coordinates.
 */
export function paintStroke(g: Graphics, pts: number[], color: number, size: number): void {
  if (pts.length < 2) return;
  if (pts.length === 2) {
    g.circle(pts[0], pts[1], size / 2).fill(color);
    return;
  }
  g.moveTo(pts[0], pts[1]);
  for (let i = 2; i < pts.length - 2; i += 2) {
    const mx = (pts[i] + pts[i + 2]) / 2;
    const my = (pts[i + 1] + pts[i + 3]) / 2;
    g.quadraticCurveTo(pts[i], pts[i + 1], mx, my);
  }
  g.lineTo(pts[pts.length - 2], pts[pts.length - 1]);
  g.stroke({ width: size, color, cap: "round", join: "round" });
}
